import { render } from "./ListFontMappingItem.vue?vue&type=template&id=4f43f104"
import script from "./ListFontMappingItem.ts?vue&type=script&lang=js"
export * from "./ListFontMappingItem.ts?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/snj4qLhS/0/titletool/titletool-nextgen-server/titletool-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__